const CaseClassify = () => import("@/vuepage/case-manage/caseClassify");
const CaseList = () => import("@/vuepage/case-manage/caseList");
const AddCase = () => import("@/vuepage/case-manage/addCase");
export default [
  {
    path: "/case-classify",
    component: CaseClassify,
    meta: [{ name: "案例管理" }, { name: "案例分类", activeRoute: "/case-classify" }],
  },

  {
    path: "/case-list",
    component: CaseList,
    name: "/case-list",
    meta: [{ name: "案例管理" }, { name: "案例列表", activeRoute: "/case-list" }],
  },

  {
    path: "/add-case",
    component: AddCase,
    name: "/add-case",
    meta: [{ name: "案例管理" }, { name: "新增案例", activeRoute: "/add-case" }],
  },
];
